import Breadcrumb from '@/components/base/Breadcrumb';

export default function ArrangementHero() {
  const highlights = [
    { icon: 'ri-file-list-3-line', label: '提交作品', value: '每人最多 3 份' },
    { icon: 'ri-scales-3-line', label: '评审打分', value: '48 位评审交叉评分' },
    { icon: 'ri-cup-line', label: '奖项设置', value: '金 / 银 / 铜 + 3 个单项奖' },
  ];

  return (
    <section className="w-full px-4 md:px-6 pt-28 md:pt-36 pb-12 md:pb-16 bg-secondary-950">
      <div className="max-w-6xl mx-auto w-full">
        <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '活动安排' }]} tone="dark" />

        <span className="mt-6 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-accent-400 uppercase">
          <span className="w-6 h-px bg-accent-400" />
          Arrangement
        </span>
        <h1 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight max-w-3xl">
          爆料大赛活动安排
        </h1>
        <p className="mt-5 max-w-3xl text-sm md:text-base text-background-300 leading-relaxed">
          从怎么报名、要交什么材料，到各阶段的具体安排、奖项设置与评审规则，这一页把参赛前需要知道的事情讲清楚。看完可以回到赛程时间表，对着日期安排自己的进度。
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-px bg-secondary-800 rounded-md overflow-hidden">
          {highlights.map((h) => (
            <div key={h.label} className="bg-secondary-900 px-6 py-6">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className={`${h.icon} text-lg`}></i>
              </span>
              <p className="mt-4 text-xs text-background-400">{h.label}</p>
              <p className="mt-1 font-heading text-lg font-semibold text-background-50">{h.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}